// src/apiConfig.js
// const LOCAL_URL = process.env.REACT_APP_BACKEND_LOCAL_URL;
const LOCAL_URL = "http://10.10.18.195:8005";
const STAGE_URL = process.env.REACT_APP_BACKEND_STAGE_URL;
const PROD_URL = process.env.REACT_APP_BACKEND_PROD_URL;


const environments = {
  local: LOCAL_URL,
  stag: STAGE_URL,
  prod: PROD_URL,
};

const activeEnvironment = environments.prod;

// Define all the API endpoints
const apiEndpoints = {
  //authorization
  login: `${activeEnvironment}/login`,
  signup: `${activeEnvironment}/signup`,
  verifyOtp: `${activeEnvironment}/verify_otp`,
  resendOtp: `${activeEnvironment}/resend-login-otp`,
  getUserDetails: `${activeEnvironment}/get_user_details`,
  addManager: `${activeEnvironment}/add_manager`,
  deactivateManager: `${activeEnvironment}/deactivate_manager`,
  addCandidate: `${activeEnvironment}/add-candidate`,
  addIndividualCandidate: `${activeEnvironment}/send-candidate-assessment`,
  getAllAssessments: `${activeEnvironment}/get_all_assessments`,
  getPosition: `${activeEnvironment}/get-position-title-list`,
  updateUser: `${activeEnvironment}/update_user_details`,
  getHistory: `${activeEnvironment}/allocated-assessment-history`,
  getReport: (id) => `${activeEnvironment}/get_final_reports/${id}`,
  viewReport: (id) => `${activeEnvironment}/ai-report/view-report/${id}`,
  sendNotification: `${activeEnvironment}/send-email-reminder`,
  addPosition: `${activeEnvironment}/add_position`,
  positionGetById: `${activeEnvironment}/get_position/`,
  changePositonStatus: `${activeEnvironment}/change_status_position`,
  fetchNewPosition: `${activeEnvironment}/fetch_new_position`,
  getOpenPosition: `${activeEnvironment}/get_open_positions`,
  addCompanyRating: `${activeEnvironment}/add_company_rating`,
  getManagerList: `${activeEnvironment}/manager_list`,

  addNotifierEmail: `${activeEnvironment}/add-emails`,

  removeNotifierEmial: `${activeEnvironment}/remove-emails`,

  // dashborad api

  getDashboardData: `${activeEnvironment}/dashboard_count`,

  // Seo data

  getSeoData: `${activeEnvironment}/get_all_seo_registration`,
  // payment
  razorpayCheckout: "https://checkout.razorpay.com/v1/checkout.js",
  getPaymentDetails: activeEnvironment + "/get-payment-details",
  sendPaymentDetails: activeEnvironment + "/payment",
  createOrder: activeEnvironment + "/create-order",
  failedPayment: activeEnvironment + "/failed-payment",
  subscriptionPlans: activeEnvironment + "/subscription-list",
  getUsersubscriptionDetails: `${activeEnvironment}/get-payment-info`,

  // add Excutive Role

  addExcutive: `${activeEnvironment}/add_executive`,
  getExecutiveList: `${activeEnvironment}/executive_list`,
  deactivateExcutive: `${activeEnvironment}/delete_executive`,

  // vendor report

  getvendorReport: `${activeEnvironment}/get-result-history-open-position`,

  // custom template
  addCustomEmailTemplate: `${activeEnvironment}/templates`,
  editCustomEmailTemplate: `${activeEnvironment}/templates/update/{id}`,

  getpartnerLead: `${activeEnvironment}/get_all_partner_leads`,

  //credit history
  creditHistory: `${activeEnvironment}/check-credit-history`,

  //update manager name
  updateManager: `${activeEnvironment}/update_manager_name`,

  //open new positiosn
  addNewPosition: `${activeEnvironment}/add_company_positions`,
  getAllPositions: `${activeEnvironment}/get_company_positions`,
  updatePosition: `${activeEnvironment}/update_company_positions`,

  //download xlx api
  getExcelData: `${activeEnvironment}/export_company_reportsdata`,

  // forgot password
  forgotPassword: `${activeEnvironment}/forgot_password`,
  resetPassword: `${activeEnvironment}/reset_password`,

  //react tour
  checkTour: `${activeEnvironment}/check/{id}`,
  closeTour: `${activeEnvironment}/complete/{id}`,
};

export { activeEnvironment, apiEndpoints };
